class DiscountClear extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', () => {
      const redirect = encodeURIComponent(`${Shopify.routes.root}cart`);
      // const cartDrawer = document.querySelector("cart-drawer");
      // const mainCartItems = document.querySelector('#main-cart cart-items');
      this.classList.add('loading');
      this.cartItems = document.querySelectorAll('cart-items');

      this.cartItems.forEach((items) => items.enableLoading());
      originFetch(`${Shopify.routes.root}discount/___?redirect=${redirect}`).then((res) => {
        return res.text();
      })
        .then(async (res) => {
          const html = new DOMParser().parseFromString(res, 'text/html');
          const discountElement = html.querySelector('apply-discount-code');
          const discounts = discountElement.getAttribute('data-discounts').split(",").map((v) => v.trim());
        })
        .finally(() => {
          publish(PUB_SUB_EVENTS.cartReload);
          this.cartItems.forEach((items) => items.disableLoading());
          this.classList.remove('loading');
        });
    });
  }
}

customElements.define('discount-clear', DiscountClear);

class CartVariantSelect extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector('select');

    this.select?.addEventListener('change', (event) => {
      const oldVariantId = Number(this.getAttribute('data-variant-id'));
      const newVariantId = Number(this.select.value);
      if (oldVariantId == newVariantId) return;
      const firstQuantity = this.getAttribute('data-first-quantity');
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.changeVariant(this.dataset.index, firstQuantity, oldVariantId, newVariantId);
    });
  }
}

customElements.define('cart-variant-select', CartVariantSelect);

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.carts = [document.getElementById('main-cart'), document.getElementById('CartDrawer')];
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === this.tagName) {
        return;
      }
      this.onCartUpdate();
    });
    this.cartReloadUnsubscriber = subscribe(PUB_SUB_EVENTS.cartReload, (event) => {
      this.reload();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    this.quantity = inputValue;
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    if (event.target.tagName == 'INPUT') {
      this.validateQuantity(event);
    }
  }

  async reload(html) {
    this.enableLoading();
    let _html = html;
    if (!html) {
      if (this.tagName == 'CART-DRAWER-ITEMS') {
        const response = await fetch(`${routes.cart_url}?section_id=cart-drawer`);
        _html = await response.text();
      } else {
        const response = await fetch(`${routes.cart_url}?section_id=main-cart-items`);
        _html = await response.text();
      }
    }
    const htmlDom = new DOMParser().parseFromString(_html, 'text/html');
    this.getSectionsToRender().forEach((section) => {
      const elementToReplace = document.getElementById(section.id)?.querySelector(section.selector);
      const element = htmlDom.getElementById(section.id)?.querySelector(section.selector)
      if (elementToReplace && element)
        elementToReplace.innerHTML = element.innerHTML;
    });
    // 购物车详情页更新空状态
    if (this.tagName != 'CART-DRAWER-ITEMS') {
      document.querySelector('#main-cart').classList = htmlDom.querySelector('#main-cart').classList;
    }
    this.disableLoading();
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      document.querySelector('cart-drawer').reload();
    } else {
      return fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart',
        section: document.getElementById('main-cart').dataset.id,
        selector: '.main-cart__cart-progress',
      },
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '#main-cart-items .js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '#main-cart-footer .js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        if (this.carts) {
          this.carts.forEach((item) => {
            if (item != null) {
              item.classList.toggle('is-empty', parsedState.item_count === 0);
            }
          });
        }
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: this.tagName, cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  /** Change cart item variant */
  changeVariant(line, firstQuantity, oldVariantId, newVariantId) {
    this.enableLoading(line);
    const quantity = Number(this.value ?? firstQuantity);
    if (isNaN(quantity)) {
      console.error('changeVariant: Quantity isNaN.')
      return false;
    }
    const quantityInputList = this.querySelectorAll('quantity-input [data-quantity-variant-id]');
    let updates = new FormData();
    for (const input of quantityInputList) {
      const variantId = Number(input.getAttribute('data-quantity-variant-id'));
      if (variantId == oldVariantId) {
        updates.append(`updates[${variantId}]`, 0);
        updates.append(`updates[${newVariantId}]`, quantity);
      } else {
        updates.append(`updates[${variantId}]`, Number(input.value));
      }
    }

    originFetch(routes.cart_update_url, {
      method: 'POST',
      headers: {
        // 'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: updates,
    })
      .then(response => {
        return response.json();
      })
      .then((state) => {
        return fetch(`${routes.cart_url}?section_id=${this.getAttribute('data-section-id')}`)
          .then((response) => response.text())
          .then((responseText) => {
            this.classList.toggle('is-empty', state.item_count === 0);
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const contents = document.querySelectorAll('#main-cart .js-contents');
            const newContents = html.querySelectorAll('.js-contents');
            for (let i = 0; i < contents.length; i++) {
              const content = contents[i];
              content.innerHTML = newContents[i].innerHTML;
            }
          })

      })
      .then(() => {
        document.querySelector('cart-drawer')?.reload();
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.querySelectorAll("#main-cart-items, #CartDrawer-CartItems");
    for (const item of mainCartItems) {
      item.classList.add('cart__items--disabled');
    }

    if (line != undefined) {
      const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
      const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

      [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

      document.activeElement.blur();
      this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }
  }

  disableLoading(line) {
    const mainCartItems = document.querySelectorAll("#main-cart-items, #CartDrawer-CartItems");
    for (const item of mainCartItems) {
      item.classList.remove('cart__items--disabled');
    }
    if (line != undefined) {
      const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
      const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

      cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
      cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    }

  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
